import React, { useContext } from "react";
import { VILLAGES_OBJ } from "../../constants/constants";
import { AppContext } from "../../context";

function RentabikeReservationInfo({ product }) {
  const info = useContext(AppContext);

  const pickup_loc =
    VILLAGES_OBJ[product?.pickup_loc] || info.rentabike?.pickup_loc;
  const pickup_date =
    product?.pickup_date ||
    info.rentabike?.pickup_date?.toISOString().split("T")[0];
  const pickup_time = product?.pickup_time || info.rentabike?.pickup_time;
  const return_loc =
    VILLAGES_OBJ[product?.return_loc] || info.rentabike?.return_loc;
  const return_date =
    product?.return_date ||
    info.rentabike?.return_date?.toISOString().split("T")[0];
  const return_time = product?.return_time || info.rentabike?.return_time;
  return (
    <div>
      <div className="ahp-reservation-row">
        <div className="ahp-reservation-label"></div>
        <div
          className="ahp-reservation-value"
          style={{ backgroundColor: "black", color: "white" }}
        >
          Levantamento
        </div>
      </div>
      <div className="ahp-reservation-row">
        <div className="ahp-reservation-label">Local</div>
        <div className="ahp-reservation-value">{pickup_loc}</div>
      </div>
      <div className="ahp-reservation-row">
        <div className="ahp-reservation-label">Data</div>
        <div className="ahp-reservation-value">{pickup_date}</div>
      </div>
      <div className="ahp-reservation-row">
        <div className="ahp-reservation-label">Hora</div>
        <div className="ahp-reservation-value">{pickup_time}</div>
      </div>
      <div className="ahp-reservation-row" style={{ marginTop: 10 }}>
        <div className="ahp-reservation-label"></div>
        <div
          className="ahp-reservation-value"
          style={{ backgroundColor: "black", color: "white" }}
        >
          Entrega
        </div>
      </div>
      <div className="ahp-reservation-row">
        <div className="ahp-reservation-label">Local</div>
        <div className="ahp-reservation-value">{return_loc}</div>
      </div>
      <div className="ahp-reservation-row">
        <div className="ahp-reservation-label">Data</div>
        <div className="ahp-reservation-value">{return_date}</div>
      </div>
      <div className="ahp-reservation-row">
        <div className="ahp-reservation-label">Hora</div>
        <div className="ahp-reservation-value">{return_time}</div>
      </div>
      <div className="ahp-reservation-row">
        <div className="ahp-reservation-label">Preço</div>
        <div className="ahp-reservation-value">
          {product.gen_price || product.total_price} €
        </div>
      </div>
    </div>
  );
}

export default RentabikeReservationInfo;
